<template lang='pug'>
  .home
    the-map-header
    the-map(v-if='isMapShown')
    the-map-menu
    transition(name='fade', mode='out-in')
      the-loader(v-show='!isLoaded')
</template>
<script>
import TheMap from '@/components/TheMap'
import TheMapMenu from '@/components/TheMapMenu'
import TheMapHeader from '@/components/TheMapHeader'
import TheLoader from '@/components/TheLoader'
import { INTERVAL } from '@/app.config'
export default {
  name: 'home',
  components: {
    TheMap,
    TheMapMenu,
    TheLoader,
    TheMapHeader
  },
  data () {
    return {
      isLoaded: false,
      isMapShown: false
    }
  },
  created () {
    // TODO: error handle
    setInterval(() => {
      this.$store.dispatch('getBusList')
    }, INTERVAL)

    setTimeout(() => {
      this.isMapShown = true
    }, 2500)
  },
  mounted () {
    setTimeout(() => {
      this.isLoaded = true
    }, 5000)
  }
}
</script>


<style scoped>
.home {
  display: flex;
  height: 100vh;
  box-sizing: border-box;
  position: relative;
  font-family: PT Sans,sans-serif;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity 1s
}
.fade-enter, .fade-leave-to {
  opacity: 0
}

</style>